import { InvocationStatus } from "@/shared/domain/actions";

export type UserFacingStatus =
  | "Pending"
  | "Provisioning"
  | "Running"
  | "Completed"
  | "Cancelled"
  | "Failed";

export const USER_FACING_STATUSES: UserFacingStatus[] = [
  "Pending",
  "Provisioning",
  "Running",
  "Completed",
  "Cancelled",
  "Failed",
];

// Mapping from user-facing status to internal statuses
export const userFacingStatusToInternalStatuses = (
  userStatus: UserFacingStatus,
): InvocationStatus[] => {
  switch (userStatus) {
    case "Pending":
      return [InvocationStatus.Queued];
    case "Provisioning":
      return [InvocationStatus.Scheduled];
    case "Running":
      return [
        InvocationStatus.Downloading,
        InvocationStatus.Processing,
        InvocationStatus.Uploading,
      ];
    case "Completed":
      return [InvocationStatus.Completed];
    case "Cancelled":
      return [InvocationStatus.Cancelled];
    case "Failed":
      return [InvocationStatus.Failed, InvocationStatus.Deadly];
  }
};
